import {createFileName} from "use-react-screenshot";

export const elementOrEmpty = (element) =>
  typeof element === "undefined" || element === null ? "" : element;

export const getHeaderValue = (property, obj) => {
  const foundValue = property
    .replace(/\[([^\]]+)]/g, ".$1")
    .split(".")
    .reduce(function (o, p, i, arr) {
      // if at any point the nested keys passed do not exist, splice the array so it doesnt keep reducing
      const value = o[p];
      if (value === undefined || value === null) {
        arr.splice(1);
      } else {
        return value;
      }
    }, obj);
  // if at any point the nested keys passed do not exist then looks for key `property` in object obj
  return foundValue === undefined ? (property in obj ? obj[property] : "") : foundValue;
};

export const jsonsHeaders = (array) =>
  Array.from(
    array.map((json) => Object.keys(json)).reduce((a, b) => new Set([...a, ...b]), [])
  );

export const jsons2arrays = (jsons) => {
  const headers = jsonsHeaders(jsons);

  // allow headers to have custom labels, defaulting to having the header data key be the label
  let headerLabels = headers;
  let headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map((header) => header.label);
    headerKeys = headers.map((header) => header.key);
  }

  const data = jsons.map((object) =>
    headerKeys.map((header) => getHeaderValue(header, object))
  );
  return [headerLabels, ...data];
};

export const joiner = (data, separator = ",", enclosingCharacter = '"') => {
  return data
    .filter((e) => e)
    .map((row) =>
      row
        .map((element) => elementOrEmpty(element))
        .map((column) => `${enclosingCharacter}${column}${enclosingCharacter}`)
        .join(separator)
    )
    .join("\n");
};

export const jsons2csv = (data) => joiner(jsons2arrays(data));

export const arrays2csv = (data) => joiner(data);

const string2csv = (data) => data.replace(/"/g, '""');

export const isJsons = (array) => {
  return (
    Array.isArray(array) &&
    array.every((row) => typeof row === "object" && !(row instanceof Array))
  );
};

export const isArrays = (array) => {
  return Array.isArray(array) && array.every((row) => Array.isArray(row));
};

const toCSV = (data) => {
  if (isJsons(data)) return jsons2csv(data);
  if (isArrays(data)) return arrays2csv(data);
  if (typeof data === "string") return string2csv(data);
};

export const downloadCSV = (data, filename) => {
  let blob = new Blob(["", toCSV(data)]);
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("download", createFileName("csv", filename));
  a.click();
  return false;
};
